import React, { useMemo } from 'react';
import { ContainerApp } from '../../types/monitoring';

interface StatusSummaryProps {
  containerApps: ContainerApp[];
}

const StatusSummary: React.FC<StatusSummaryProps> = ({ containerApps }) => {
  const summary = useMemo(() => {
    const total = containerApps.length;
    const running = containerApps.filter(app => app.status.toLowerCase() === 'running').length;
    const stopped = containerApps.filter(app => app.status.toLowerCase() === 'stopped').length;
    const warning = containerApps.filter(app => app.status.toLowerCase() === 'warning').length;
    const other = total - running - stopped - warning;
    
    return { total, running, stopped, warning, other };
  }, [containerApps]);

  const cards = [
    {
      title: 'Total Apps',
      value: summary.total,
      bgColor: 'bg-gray-100 dark:bg-gray-700',
      textColor: 'text-gray-800 dark:text-white',
    },
    {
      title: 'Running',
      value: summary.running,
      bgColor: 'bg-green-100 dark:bg-green-800',
      textColor: 'text-green-800 dark:text-green-100',
    },
    {
      title: 'Stopped',
      value: summary.stopped,
      bgColor: 'bg-red-100 dark:bg-red-800',
      textColor: 'text-red-800 dark:text-red-100',
    },
    {
      title: 'Warning',
      value: summary.warning,
      bgColor: 'bg-yellow-100 dark:bg-yellow-800',
      textColor: 'text-yellow-800 dark:text-yellow-100',
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {cards.map((card, index) => (
        <div key={index} className={`${card.bgColor} rounded-lg shadow p-4`}>
          <h3 className={`text-sm font-medium ${card.textColor}`}>{card.title}</h3>
          <p className={`text-3xl font-bold ${card.textColor} mt-1`}>{card.value}</p>
        </div>
      ))}
    </div>
  );
};

export default StatusSummary;